import { hooks } from '../../../config/api';
var VISIBILITY_FILTER = 'alternate';
var PAGINATION = {
  number: 1,
  size: 5
};
export var useFindClientAliases = function useFindClientAliases(contactId, groupId) {
  var _response$data$data, _response$data;
  var filters = {
    provider: groupId,
    visibility: VISIBILITY_FILTER
  };
  var options = {
    page: PAGINATION,
    queryConfig: {
      placeholderData: undefined
    }
  };
  var _ref = hooks.useFind("people/".concat(contactId, "/client_aliases"), filters, options) || {},
    response = _ref.data,
    isLoading = _ref.isLoading;
  var aliases = (_response$data$data = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) !== null && _response$data$data !== void 0 ? _response$data$data : [];
  return {
    aliases: aliases,
    isLoading: isLoading
  };
};
//# sourceMappingURL=useFindClientAliases.js.map